import { Injectable } from '@angular/core';
import { ConfigService } from '@core/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class AppRedirectService {
  constructor(private configService: ConfigService) {}
    deviceCheck() {
        const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
        if (/android/i.test(userAgent) || /Linux/.test(userAgent)) {
            return 'android';
          }
      
          if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
            return 'iphone';
          }
      
          return 'other';
    }
  // Detect if the device is Android or iPhone
  detectDevice(): 'android' | 'ios' | 'unknown' {
    const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
    
    if (/android/i.test(userAgent)) {
      return 'android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
      return 'ios';
    }

    return 'unknown';
  }

  // Redirect to App if installed, otherwise redirect to Play Store or App Store
  redirectToAppOrStore() {
    const device = this.detectDevice();

    if (device === 'android') {
      this.checkAndroidApp();
    } else if (device === 'ios') {
      this.checkiOSApp();
    }
  }
  public checkAndroidApp() {
    window.location.href = this.configService.get('appUrls').android;
  }

  public checkiOSApp() {
    window.location.href = this.configService.get('appUrls').ios;
  }

}